export function isDevEnv(): boolean {
  return window.location.host.startsWith('localhost')
    || window.location.host.startsWith('dev-');
}

export function isLocalEnv(): boolean {
  return window.location.href.includes('localhost');
}
